<template>
    <div id="content-main" class="allColors">
        <TopNavi id="top-conatiner" @getTopSliderTop="setTopSliderTop"></TopNavi>
        <div id="content-conatiner">
            <transition name="slide">
                <TopSlider v-show="showslider" ref="topslider"></TopSlider>
            </transition>
            <ContentContainer></ContentContainer>
            <Footer @getTopSliderTop="setTopSliderTop"></Footer>
        </div>
<!-- 
        <el-dialog :visible.sync="dialogVisible" custom-class="cpopup">
            <div class="logo-big-top"></div>

            <div style="text-align:right;"><b>Neuhaus, 01.05.2020</b><br /><br /></div>
            <span>
                <b>Sehr geehrter Reisegast, </b><br />
                <b>Liebe Freunde der LWW, </b><br />
                <br />
                in diesen außergewöhnlichen Zeiten stehen wir Ihnen als <b>Ihr Reise- und Busunternehmen</b> zur Seite!<br />
                <br />
                Sehr gerne schenken wir Ihnen auch in Zukunft zahlreiche Gelegenheiten, die Welt zu entdecken! 
                <br />
                <br />
                Wir wünschen uns, Sie mit unserer Arbeit weiterhin zu erreichen, glücklich zu machen und Ihr Reise-Herz höher und höher schlagen zu lassen!
                <br />
                <br />
                Ihren zukünftigen Reisewünschen begegnen wir nach wie vor mit Freude! Unsere Hoffnungen, in die Saison starten zu dürfen, wurden (vorerst) nicht erfüllt. Wir bleiben bei den Lockerungen der Maßnahmen zur Eindämmung der Corona-Pandemie gegenwärtig außen vor. Obwohl wir versuchen, optimistisch zu bleiben und davon überzeugt sind, dass unsere Busse unter definierten Auflagen irgendwann wieder rollen dürfen, gilt es als selbstverständlich, die Entscheidungen der Bundesregierung zu akzeptieren. 
                <br />
                <br />
                <b>Aufgrund der Allgemeinen Reisewarnung des Auswärtigen Amtes haben wir bereits alle Reisen in das Ausland bis 14.06.2020 storniert.</b> Von einer Absage oder Terminverschiebung betroffen sind weiterhin alle Reisen, denen eine Großveranstaltung (wie z. B. die Hanse Sail und Störtebeker) zu Grunde liegt. Abreisen im innerdeutschen Raum, gelten bis zur nächsten allgemeingültigen Verordnung –erwartet am 06.05.2020 – als durchführbar. Besteht der Verdacht eines konkreten Risikos für Ihr persönliches Wohlergehen und damit eine Gesundheitsgefährdung oder sprechen behördlich angeordnete Maßnahmen gegen eine Busreise, wird die Durchführung dieser Reisen selbstverständlich neu bewertet. Die Gesundheit unserer Gäste und Mitarbeiter hat für uns oberste Priorität!
                <br />
                <br />
                Wir bitten betroffene Gäste von direkten Besuchen und Nachfragen abzusehen, bis Sie durch uns kontaktiert werden. Ein geordnetes Abarbeiten der Vorgänge wird somit gewährleistet. 
                <br />
                <br />
                Unsere Mitarbeiter bemühen sich um eine schnellstmögliche Information aller betroffenen Reisegäste. Wir bitten darum, von direkten Besuchen und Nachfragen abzusehen <b>(aktuelle ausschließlich telefonische Erreichbarkeit von Montag bis Freitag: 09:00 – 12:00 Uhr).</b> Ein geordnetes Abarbeiten der Vorgänge wird somit gewährleistet. 
                <br />
                <br />
                Bereits geleistete Zahlungen zu den entsprechenden Reisen erstatten wir in den nächsten Tagen zurück.
                <br />
                <br />
                Wir hoffen, dass Sie uns weiterhin Ihr Vertrauen schenken und uns die Treue halten.<br /><br />
               
                Wir sichern Ihnen unsere Solidarität und Menschlichkeit zu und bitten Sie uns gegenüber um Selbiges!<br /><br />

                <b>Ihr Manfred Lipfert & Team </b>
            </span>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogVisible = false">Schließen</el-button>
            </span>
        </el-dialog> -->

        <cookie-law buttonText="Einverstanden">
            <div slot="message">
                Um Ihnen ein besseres Nutzererlebnis zu bieten, verwenden wir Cookies. Mit der Nutzung unserer Website erklären Sie sich mit der Verwendung von Cookies einverstanden. Weitere Informationen, sowie Ihre Widerspruchsmöglichkeiten finden Sie in unseren Datenschutz-Erklärung. Klicken Sie
                dazu hier. <router-link to="/article/72" style="color:#b90202; text-decoration:none;"> Datenschutz</router-link>
            </div>
        </cookie-law>
    </div>
</template>

<script>
import TopNavi from "@/components/TopNavi.vue"
import TopSlider from "@/components/TopSlider.vue"
import ContentContainer from "@/components/ContentContainer.vue"
import Footer from "@/components/Footer.vue"
import CookieLaw from "vue-cookie-law"

export default {
    name: "container",
    data() {
        return {
            showslider: true,
            dialogVisible: false
        }
    },
    components: {
        TopNavi,
        TopSlider,
        ContentContainer,
        Footer,
        CookieLaw
    },
    mounted() {
        setTimeout(() => {
            if (core.router.history.current.path !== "/") {
                this.showslider = false
            }
        }, 1000)

        this.dialogVisible = true
    },
    methods: {
        setTopSliderTop() {
            this.showslider = false
        }
    }
}
</script>

<style>
@media (max-width: 600px) {
    .cpopup {
        width: 90% !important;
        padding: 10px;
        top: -12% !important;
    }
    .cpopup span,
    .cpopup div {
        font-size: 14px !important;
        word-break: normal !important;
    }
    .logo-big-top {
        width: 250px;
        height: 70px;
    }
}
@media (min-width: 600px) and (max-width: 960px) {
    .cpopup {
        width: 80% !important;
        padding: 15px;
        top: -12% !important;
    }
    .cpopup span,
    .cpopup div {
        font-size: 16px !important;
        word-break: normal !important;
    }
    .logo-big-top {
        width: 250px;
        height: 70px;
    }
}
@media (min-width: 960px) and (max-width: 1264px) {
    .cpopup {
        width: 90% !important;
        padding: 15px;
        top: -12% !important;
    }
    .cpopup span,
    .cpopup div {
        font-size: 16px !important;
        word-break: normal !important;
    }
    .logo-big-top {
        width: 300px;
        height: 80px;
    }
}
@media (min-width: 1264px) and (max-width: 1904px) {
    .cpopup {
        width: 80% !important;
        padding: 15px;
        top: -12% !important;
    }
    .cpopup span,
    .cpopup div {
        font-size: 16px !important;
        word-break: normal !important;
    }
    .logo-big-top {
        width: 350px;
        height: 100px;
    }
}
@media (min-width: 1904px) {
    .cpopup {
        width: 60% !important;
        padding: 20px;
        top: -10% !important;
    }
    .cpopup span,
    .cpopup div {
        font-size: 16px !important;
        word-break: normal !important;
    }
    .logo-big-top {
        width: 400px;
        height: 100px;
    }
}
.cpopup span,
.cpopup div {
    font-size: 16px;
    clear: both;
}
.logo-big-top {
    background-size: contain;
    background-repeat: no-repeat;
    float: right;
    margin-bottom: 20px;
    background-image: url(" ../assets/images/logo_big.jpg ");
}

#content-main {
    height: 100%;
}
#top-conatiner {
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    height: 60px;
    z-index: 2;
    box-shadow: 0px 4px 13px 0px rgba(0, 0, 0, 0.75);
}
#content-conatiner {
    position: fixed;
    top: 60px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    overflow-y: auto;
    background-color: #e6e6e6;
}
ul {
    cursor: pointer;
}

.slide-enter-active {
    transition-duration: 0.1s;
    transition-timing-function: ease-in;
}

.slide-enter-to,
.slide-leave {
    max-height: 100%;
    overflow: hidden;
}

.slide-enter,
.slide-leave-to {
    overflow: hidden;
    max-height: 0;
}
</style>



